import { useEffect } from 'react';
import './PaymentMethods.scss';
import PaymentMethodItem from '../../../components/PaymentMethodItem';
import Loading from '../../../components/Loading';
import { usePaymentMethodsContext } from '../../../hooks/usePaymentMethods';

const { Button, MessageBox, Notification } = require('@paymongo/seeds');

const paymentMethodsUI = {
  atome: {
    icon: "atome",
    label: "Atome"
  },
  billease: {
    icon: "billease",
    label: "Billease"
  },
  brankas_bdo: {
    icon: "bdo",
    label: "BDO (via Brankas)"
  },
  brankas_landbank: {
    icon: "landbank",
    label: "Landbank (via Brankas)"
  },
  brankas_metrobank: {
    icon: "metrobank",
    label: "Metrobank (via Brankas)"
  },
  brankas_rcbc: {
    icon: "rcbc",
    label: "RCBC (via Brankas)"
  },
  card: {
    icon: "visaMastercard",
    label: "Credit / Debit Card"
  },
  crypto: {
    icon: "crypto",
    label: "Cryptocurrency"
  },
  dob: {
    icon: "bpiLight",
    label: "BPI"
  },
  dob_ubp: {
    icon: "ubp",
    label: "UnionBank"
  },
  gcash: {
    icon: "gcash",
    label: "GCash"
  },
  grab_pay: {
    icon: "grabpay",
    label: "GrabPay"
  },
  paymaya: {
    icon: "mayaLight",
    label: "Maya"
  },
  qrph: {
    icon: "qrph",
    label: "QR Ph"
  },
  shopee_pay: {
    icon: "shopeepay",
    label: "ShopeePay"
  },
  google_pay_card: {
    icon: "googlepay",
    label: "Google Pay"
  },
}

const PaymentMethods = () => {
  const context = usePaymentMethodsContext();

  useEffect(() => {
    context.loadPaymentMethods();
  }, [])

  const onSubmit = () => {
    context.savePaymentMethods()
  }

  const showNoPaymentMethodSelectedError = context.isChanged && context.noSelectedPaymentMethod;
  const isButtonDisabled = !context.isChanged || context.noSelectedPaymentMethod;
  return (
    <Loading loading={context.isLoading}>
      <div className="payment-methods">
        <h3>Payment Methods</h3>

        <p className="text">
          Select which payment methods you want to accept in your Shopify Store.
        </p>

        <div className="payment-methods__container --mb-lg">
          {
            context.data.map((item) => (
              <PaymentMethodItem
                key={item.payment_method}
                checked={!item.configured ? false : item.allowed}
                className="payment-methods__item"
                onChange={(value: any) => context.setValue(item.payment_method, value)}
                disabled={!item.configured}
                { ...paymentMethodsUI[item.payment_method as keyof typeof paymentMethodsUI] }
              />
            ))
          }
        </div>

        {
          showNoPaymentMethodSelectedError &&
          <MessageBox className="--mb-md" type="error">
            You must select at least one (1) payment method.
          </MessageBox>
        }

        <Button className="text payment-methods__button --bold --mb-md"
          onClick={onSubmit} disabled={isButtonDisabled} loading={context.isButtonLoading}>
          Save payment methods
        </Button>

        <Notification
          transition="slide fade"
          position="bottom right"
        />
      </div>
    </Loading>
  );
}

export default PaymentMethods;
